import { render, staticRenderFns } from "./graph-legend-label.vue?vue&type=template&id=05d84c60"
import script from "./graph-legend-label.vue?vue&type=script&lang=js"
export * from "./graph-legend-label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports